import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '', {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  }
});

// Handle invalid/expired refresh tokens by clearing the session
supabase?.auth?.onAuthStateChange((event, session) => {
  if (event === 'TOKEN_REFRESHED' && !session) {
    supabase?.auth?.signOut();
  }
});

// Intercept refresh token errors globally
const originalGetSession = supabase?.auth?.getSession?.bind(supabase?.auth);
supabase.auth.getSession = async () => {
  try {
    const result = await originalGetSession();
    if (result?.error?.message?.toLowerCase()?.includes('refresh token')) {
      await supabase?.auth?.signOut();
      return { data: { session: null }, error: null };
    }
    return result;
  } catch (err) {
    if (err?.message?.toLowerCase()?.includes('refresh token')) {
      await supabase?.auth?.signOut();
      return { data: { session: null }, error: null };
    }
    throw err;
  }
};
